import { SVGFilterStatus } from 'components/maps';

const BoldFilterSelected: React.FunctionComponent = () => {
  return (
    <filter id={`${SVGFilterStatus.RED_SELECTED}`}>
      <feColorMatrix
        values='0 1 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 1 0'
      />
      <feMorphology operator='dilate' radius={30} result='outlineMorph' />
      <feMerge>
        <feMergeNode in='outlineMorph' />
        <feMergeNode in='SourceGraphic' />
      </feMerge>
    </filter>
  );
};

export default BoldFilterSelected;
